import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useAddTimedPlusToBidCanvasExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.AddTimedplusToBidCanvas,
        AmplitudeVariants.AddTimedplusToBidCanvas.Treatment
    );
